export default "__VITE_ASSET__Twq8XW8b__"